import { render } from "./notFound.vue?vue&type=template&id=0cc0680c&scoped=true"
import script from "./notFound.vue?vue&type=script&lang=js"
export * from "./notFound.vue?vue&type=script&lang=js"

import "./notFound.vue?vue&type=style&index=0&id=0cc0680c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc0680c"]])

export default __exports__